import axios from 'axios';

// import router from '@/router';
import auth from '@/utils/auth';

import {
  GET_EXPENSES,
  GET_EXPENSES_ERROR,
  GET_EXPENSES_SUCCESS,

  GET_RECEVABLE_PAYABLE,
  GET_RECEVABLE_PAYABLE_ERROR,
  GET_RECEVABLE_PAYABLE_SUCCESS,

  GET_INCOME_AND_EXPENSES_BY_MONTHS,
  GET_INCOME_AND_EXPENSES_BY_MONTHS_ERROR,
  GET_INCOME_AND_EXPENSES_BY_MONTHS_SUCCESS,

  GET_PROVIDENT_FUND,
  GET_PROVIDENT_FUND_ERROR,
  GET_PROVIDENT_FUND_SUCCESS,

} from './constants';

export default {
  async [GET_EXPENSES]({ commit }, args) {
    try {
      commit(GET_EXPENSES);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/expenses`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_EXPENSES_SUCCESS, response.data);
    } catch (err) {
      commit(GET_EXPENSES_ERROR, err);
    }
  },

  async [GET_INCOME_AND_EXPENSES_BY_MONTHS]({ commit }, args) {
    try {
      commit(GET_INCOME_AND_EXPENSES_BY_MONTHS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/income-and-expenses-by-months`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_INCOME_AND_EXPENSES_BY_MONTHS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_INCOME_AND_EXPENSES_BY_MONTHS_ERROR, err);
    }
  },

  async [GET_RECEVABLE_PAYABLE]({ commit }, args) {
    try {
      commit(GET_RECEVABLE_PAYABLE);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/recevable-payable/transactions`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        // params: {
        //   includeRecevable: true,
        //   includePayable: true,
        //   filters: args.duePeriod,
        // },
      });
      commit(GET_RECEVABLE_PAYABLE_SUCCESS, response.data);
    } catch (err) {
      commit(GET_RECEVABLE_PAYABLE_ERROR, err);
    }
  },

  async [GET_PROVIDENT_FUND]({ commit }, args) {
    try {
      commit(GET_PROVIDENT_FUND);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/provident-fund`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_PROVIDENT_FUND_SUCCESS, response.data);
    } catch (err) {
      commit(GET_PROVIDENT_FUND_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Dashboard/actions.js